import trainingData from '../data/further_training.json';
import { FurtherTraining } from '../models/further-training.interface';

export class FurtherTrainingService {
    private training: FurtherTraining[] = [];

    constructor() {
        this.training = trainingData.further_training as FurtherTraining[];
    }

    getTraining(): FurtherTraining[] {
        return this.training;
    }
}

export const furtherTrainingService = new FurtherTrainingService();
